import LogRocket from "logrocket";
import Cookie from "js-cookie";

const elr = document.querySelector( "meta[name=\"elr\"]" ).getAttribute( "content" ) === "true";
const lrp = document.querySelector( "meta[name=\"lrp\"]" ).getAttribute( "content" );
const version = document.querySelector( "meta[name=\"version\"]" ).getAttribute( "content" );

const sessionCaptureChange = 0.33;

const allowedPages = [
  "checkout",
  "basket",
  "access",
];

function isAllowedPage () {
  const path = window.location.pathname;
  const split = path.split( "/" );

  let result = false;

  if ( split.length >= 1 ) {
    const page = split[1];
    result = allowedPages.includes( page );
  }

  return result;
}

function init () {
  if ( process.env.NODE_ENV === "production" ) {
    if ( elr && ( Math.random() < sessionCaptureChange || isAllowedPage() ) ) {
      LogRocket.init( lrp, {
        release: version,
      } );

      const user = Cookie.get( "CurrentLoggedInUser" );
      if ( user ) {
        const split = user.split( "=" );
        if ( split && split.length >= 1 ) {
          const webAccountId = split[1];
          if ( webAccountId ) {
            LogRocket.identify( webAccountId );
          }
        }
      }
    }
  }
}

export default { init };
